import React, { FC } from 'react';

import * as Styles from './_blankCard.module.scss';

type BlankCardProps = {
    children: JSX.Element;
    containerStyle?: string;
}

const BlankCard: FC<BlankCardProps> = ({
    children,
    containerStyle,
}) => {
    return (
        <div className={`${Styles.container}${containerStyle ? ` ${containerStyle}` : ''}`}>
            {children}
        </div>
    );
};

export default BlankCard;
